import HealthIndicatorMeasure from './HealthIndicatorMeasure.jsx';

export default HealthIndicatorMeasure;